import PropTypes from "prop-types";
import * as React from "react";
import useInfluencerServices from "../../../hooks/useInfluencerServices";
import { SectionHead, Switch, Typography } from "../../../themeV2";
import css from "./sections.module.css";

const SignerServices = function SignerServices({
  signer,
  services,
  showName,
  readOnly,
  onToggle,
}) {
  const {
    services: offered,
    isLoading,
    isError,
  } = useInfluencerServices(signer.influencerId);
  const active = offered.filter((service) => service.isActive);
  const isOn = (id) =>
    services.some((s) => s.influencerServiceId === id && s.active);

  return (
    <fieldset className={css.fieldset}>
      {showName && <legend className={css.legend}>{signer.name}</legend>}
      {isLoading && (
        <Typography variant="body-md" color="variant" as="p">
          Loading services…
        </Typography>
      )}
      {isError && (
        <Typography variant="body-md" color="variant" as="p">
          Couldn&apos;t load services for {signer.name}. Their settings are kept
          as they are.
        </Typography>
      )}
      {!isLoading && !isError && active.length === 0 && (
        <Typography variant="body-md" color="variant" as="p">
          No services set up for {signer.name}.
        </Typography>
      )}
      {active.map((service) => (
        <Switch
          key={service.influencerServiceId}
          label={service.label}
          disabled={readOnly}
          checked={isOn(service.influencerServiceId)}
          onCheckedChange={(enabled) =>
            onToggle({
              influencerServiceId: service.influencerServiceId,
              enabled,
            })
          }
        />
      ))}
    </fieldset>
  );
};

SignerServices.propTypes = {
  onToggle: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  services: PropTypes.arrayOf(PropTypes.object).isRequired,
  showName: PropTypes.bool,
  signer: PropTypes.shape({
    influencerId: PropTypes.number.isRequired,
    name: PropTypes.string,
  }).isRequired,
};

const ServicesSection = function ServicesSection({
  state,
  dispatch,
  visibleSignerIds,
  readOnly,
}) {
  const signers = state.signers.filter((s) =>
    visibleSignerIds.includes(s.influencerId),
  );

  return (
    <section className={css.section}>
      <SectionHead title="Services" as="h3" />
      {signers.map((signer) => (
        <SignerServices
          key={signer.influencerId}
          signer={signer}
          services={state.services}
          showName={signers.length > 1}
          readOnly={readOnly}
          onToggle={(change) => dispatch({ type: "toggleService", ...change })}
        />
      ))}
    </section>
  );
};

ServicesSection.propTypes = {
  dispatch: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  state: PropTypes.object.isRequired,
  visibleSignerIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default ServicesSection;
